<template>
  <div class="wt-checkbox-toggle wt2-sg">
    <div class="-header">
      <!-- <span class="-label-left" v-text="field.label" />
      <slot name="tooltip" /> -->
      <div class="-title-box wt2-text-n wt2-color-normal">
        {{ field.label }}
      </div>
      <slot name="tooltip"></slot>
      <div class="-header-right-area">
        <wt-toggle v-model="checkboxValue" />
        <div
          v-if="allowStoryboardingControls"
          @click="lockUnlockStoryboardField"
          class="-lock-icon"
        >
          <i
            class="wticon wticon-unlocked"
            title="Lock Field for Editing"
            v-if="isStoryboardFieldEditable"
          />
          <i
            class="wticon wticon-locked"
            title="Unlock Field for Editing"
            v-else
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fieldsMixin from '../mixins/fields.vue';

export default {
  props: {
    field: {
      type: Object,
      required: true,
      validator(value) {
        return _.every(['label'], (prop) => _.includes(_.keys(value), prop));
      },
    },
    fieldDataModel: {
      type: Object,
      required: false,
    },
    allowStoryboardingControls: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  mixins: [fieldsMixin],

  data() {
    return {
      checkboxValue: null,
    };
  },

  created() {
    this.checkboxValue = this.isTrue(
      _.isDefined(this.field.value) ? this.field.value : this.field.defaultValue
    );
    this.emitChange({ newValue: this.checkboxValue, makeDirty: false });
    this.unwatch = this.$watch('checkboxValue', (newValue) => {
      this.emitChange({ newValue });
    });
  },

  beforeDestroy() {
    this.unwatch();
  },

  mounted() {
    this.fieldReadyNextTick();
  },

  computed: {
    isStoryboardFieldEditable() {
      return this.fieldDataModel ? this.fieldDataModel.editable : true;
    },
  },

  methods: {
    lockUnlockStoryboardField() {
      this.$emit('storyboardingControlsChanged', {
        name: 'editable',
        value: !this.isStoryboardFieldEditable,
      });
    },
    isTrue(value) {
      if (_.isBoolean(value)) {
        return value;
      } else if (_.isString(value)) {
        return (value || '').toLowerCase() === 'true';
      } else {
        return false;
      }
    },
  },
};
</script>
